var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItau(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#003399;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1112.8,1844.7c0,59.7,48.5,79.3,82.1,79.3c78.4,0,158.7-49.5,158.7-129.8v-84.9 c-17.7,14-47.6,25.2-120.4,35.5C1166.9,1755.9,1112.8,1772.8,1112.8,1844.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2045.4,1.9L457.4,0.9C206.3,0,1.9,205.4,1.9,455.6L0,2043.5c0,250.2,204.4,454.6,454.6,455.6l1588.9,0.9 c250.2,0,455.5-204.4,455.5-454.6V457.4C2500,207.2,2294.6,1.9,2045.4,1.9z M422.9,2029.5H232.5l0.9-889.7h190.4L422.9,2029.5z  M1966,1140.8h181.1l-128.8,141.9h-127L1966,1140.8z M883.1,1494.6H773l-0.9,357.5c0,39.2,1.9,54.2,73.8,54.2 c11.2,0,24.3-1.9,36.4-2.8v131.7c-27.1,0.9-55.1,2.8-83.1,2.8h-23.3c-153.1,0-180.2-57.9-180.2-142.8v-400.5H505v-124.2h91.5 v-229.6H773l0,229.6h110.2V1494.6z M1374.2,2030.4c-10.3-31.7-13.1-41.1-16.8-77.5c-39.2,40.1-96.1,95.2-217.5,95.2 c-99.9,0-204.4-56-204.4-192.3c0-128.8,84-195.1,197-211l158.7-23.3c28-3.7,62.6-14.9,62.6-52.3c0-72.8-71-76.6-116.7-76.6 c-87.8,0-103.6,53.2-109.2,91.5H956.9c21.5-201.6,164.3-230.6,301.5-230.6c95.2,0,267,28.9,267,192.3l0,356.6 c0,0.9,0.9,54.1,0.9,127L1374.2,2030.4z M2267.5,2030.4h-169.9V1938h-1.9c-40.1,70.9-112,111.1-204.4,110.1 c-132.6,0-228.7-74.7-228.7-242.7l0.9-434.1H1840v408.9c-1,101.8,59.7,122.3,114.8,122.3c57.8,0,136.3-33.6,136.3-150.3v-380.9 h176.4l0,0V2030.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItau);
export default __webpack_public_path__ + "static/media/itau.dd964226e718c8e1afeb1ee6b4f97ddc.svg";
export { ForwardRef as ReactComponent };